import { LOCAL_STORAGE } from 'app/commons/constants'
import coreApi from 'app/services/coreApi'

import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

interface HotlineCustomer {
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneCountryCode: string
  config?: Record<string, any>
  restore_id?: string
  externalId?: string
}

function FreshChat(): null {
  const customerId = useSelector((state: any) => state.auth.login.accounts.id)
  const location = useLocation()

  const isLiveTrackingPage = (): boolean => {
    const pathLiveTracking = /tracking/g
    return pathLiveTracking.test(location.pathname)
  }

  useEffect(() => {
    initialize()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerId])

  const hotlineConfig = async (hotlineCustomer: HotlineCustomer): Promise<void> => {
    let time = 0
    if (window.fcWidget && window.fcWidget.isInitialized) {
      window.fcWidget.destroy()
      time = 500
    }
    // init again if login
    setTimeout(() => {
      if (window.fcWidget) {
        window.fcWidget.init({
          ...hotlineCustomer,
          config: {
            ...hotlineCustomer.config,
            ...(isLiveTrackingPage() ? { cssNames: { widget: 'fc_live_tracking' } } : {}),
          },
        })
        if (hotlineCustomer.restore_id == null) {
          window.fcWidget.on('user:created', (resp: any) => {
            const status = resp && resp.status
            const data = resp && resp.data
            if (status === 200) {
              window.fcWidget.user.setProperties({
                firstName: hotlineCustomer.firstName,
                lastName: hotlineCustomer.lastName,
                email: hotlineCustomer.email,
                phone: hotlineCustomer.phone,
                phoneCountryCode: hotlineCustomer.phoneCountryCode,
              })
              if (data && data.restoreId && hotlineCustomer.externalId) {
                coreApi.updateFreshChatCustomer({
                  restore_id: data.restoreId,
                  customer_id: hotlineCustomer.externalId,
                })
              }
            }
          })
        }
        window.fcWidget.on('widget:loaded', () => {
          window.fcWidget.user.update({
            meta: {
              BookingId: 'None',
            },
          })
        })
      }
    }, time)
  }

  const initialize = async (): Promise<void> => {
    const token = localStorage.getItem(LOCAL_STORAGE.ACCESS_TOKEN)
    try {
      const result = await coreApi.getHotlineCurrentCustomer({ ...(token ? { access_token: token } : {}) })
      hotlineConfig(result)
    } catch (error) {
      console.debug(error)
    }
  }
  return null
}

export default FreshChat
